module.exports = __webpack_public_path__ + "img/icon_folder_on.9d5fcec4.svg";